export default __webpack_public_path__ + "static/media/file_word_32.6650ee76.svg";